import { EntityPais } from "../Domain/EntityPais";
import { EntityParams } from "../Domain/EntityParams";
import { RepositoryMain } from "../Domain/RepositoryMain";

export class UseCaseSelectPais {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec(params: EntityParams): Promise<Array<EntityPais>> {
        return await this._exec(params);
    }

    private async _exec(params: EntityParams): Promise<Array<EntityPais>> {
        return await this.repository.selectPais(params);
    }
}